export const Plus = `<svg title="Plus" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11 13V20H13V13H19.9999V11L13 11V4H11V11L3.99988 11V13H11Z" fill="currentcolor"/>
</svg>`;